// Mask that allows 1-2 digits before the decimal and an optional decimal with 1 digit after
// allows 1.0 to 21.0
export const horseHeightInHandsMask = (value = '') => {
  const chars = value.split('');
  let maskArray = [];

  chars.map((char, index) => {
    if (
      maskArray[maskArray.length - 2] === '.' ||
      (maskArray.length === 2 && char !== '.')
    ) {
      return;
    }

    if (index === 0) {
      maskArray.push(/[1-9]/);
    } else if (char === '.' || (index === 1 && chars[0] > '2')) {
      maskArray.push('.'); // Decimal point
      maskArray.push(/\d/);
    } else {
      maskArray.push(/\d/); // One digit
    }
  });

  return maskArray.length > 0 ? maskArray : [/\d/];
};

// Mask that allows 1-4 digits before the decimal and an optional decimal with 1 digit after
// allows 100 to 9999.9
export const weightMask = (value = '') => {
  const chars = value.split('');
  let maskArray = [];

  chars.map((char, index) => {
    if (
      maskArray[maskArray.length - 4] === '.' ||
      (maskArray.length === 4 && char !== '.')
    ) {
      return;
    }

    if (index === 0) {
      maskArray.push(/[1-9]/);
    } else if (char === '.') {
      maskArray.push('.'); // Decimal point
      maskArray.push(/\d/); // Restrict to 1 digit after the decimal
    } else {
      maskArray.push(/\d/); // One digit
    }
  });

  return maskArray.length > 0 ? maskArray : [/\d/, /\d/, /\d/];
};

export const dateMask = (rawValue = '') => {
  let monthPortion =
    rawValue[0] === '1' ? [/[01]/, /[0-2]/] : [/[01]/, /[0-9]/];
  let dayPortion =
    rawValue[3] === '3' ? ['/', /[0-3]/, /[01]/] : ['/', /[0-3]/, /[0-9]/];
  let yearPortion =
    rawValue[6] === '2'
      ? ['/', /[12]/, /[0]/, /[0-9]/, /[0-9]/]
      : ['/', /[12]/, /[09]/, /[0-9]/, /[0-9]/];

  return monthPortion.concat(dayPortion, yearPortion);
};
